(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible-video-child"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (!details.matches('.collapsible-block--video') || !details.open) return;

    const mount = details.querySelector('[data-video-mount]');
    const template = details.querySelector('[data-video-template]');
    if (!mount || !template || mount.dataset.loaded) return;

    mount.innerHTML = '';
    mount.appendChild(template.content.cloneNode(true));
    mount.dataset.loaded = 'true';
  }, true);
  } catch(e) { console.error(e); }
})();

})();
